import { findItem } from './findItem';
import indexedPageView from 'owa-service/lib/factory/indexedPageView';
import { tryConsumeFindMailFolderItemResponse } from 'owa-session-store/lib/services/sessionDataResponseStash';
import getFindItemTraversal from './utils/getFindItemTraversal';
/**
 * The FindItemWithStartIndex is used today to load rows when we want to load them from the beginning (or 0th index)
 * This is currently used in load initial rows and in reload scenarios
 * @param baseFolderId the base folder id
 * @param startIndex the startIndex to load the table
 * @param paging the paging type
 * @param viewFilter the view filter
 * @param sortResults the primary and secondary sort by results
 * @param focusedViewFilter the focused view filter
 * @param findItemShapeName - the shape for the request
 * @param shouldTryToUseSessionDataResponse Indicates if we should try to use the result returned in session data response
 * @param options - optional parameters to be passed to request (method and/or headers)
 * @param categoryName - the category name
 * @returns a promise of type FindItemResponseMessage
 */
export default function findItemWithStartIndex(baseFolderId, startIndex, rowsToLoad, viewFilter, sortResults, focusedViewFilter, findItemShapeName, shouldTryToUseSessionDataResponse, options, categoryName) {
    if (shouldTryToUseSessionDataResponse) {
        var sessionDataFindMailFolderItemResponse_1 = tryConsumeFindMailFolderItemResponse(baseFolderId.Id, 0 /* startIndex */);
        if (sessionDataFindMailFolderItemResponse_1) {
            // Return the session data response if available instead of going to the server
            return new Promise(function (resolve) {
                resolve(sessionDataFindMailFolderItemResponse_1.Body);
            });
        }
    }
    var paging = indexedPageView({
        BasePoint: 'Beginning',
        Offset: 0 /* startIndex */,
        MaxEntriesReturned: rowsToLoad,
    });
    return findItem(baseFolderId, paging, viewFilter, sortResults, focusedViewFilter, findItemShapeName, options, categoryName, getFindItemTraversal(viewFilter));
}
//# sourceMappingURL=findItemWithStartIndex.js.map